'use client';

import { useEffect } from 'react';

interface FilterSectionProps {
  onFilterChange: (filters: FilterState) => void;
}

interface FilterState {
  region: string;
  language: string;
  budget: string;
  searchQuery: string;
}

export default function FilterSection({ onFilterChange }: FilterSectionProps) {
  // Default filters (no filtering)
  useEffect(() => {
    onFilterChange({
      region: 'all',
      language: 'all',
      budget: 'all',
      searchQuery: '',
    });
  }, [onFilterChange]);

  // 👇 UI completely hidden
  return null;
}